import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import facebookIcon from "../img/ri_facebook-fill.png";
import twitterIcon from "../img/akar-icons_x-fill.png";
import instagramIcon from "../img/fe_instagram.png";
import callIcon from "../img/mdi_call.png";
import logoIcon from "../img/logo.png";
import ic_baseline from "../img/ic_baseline-mail.png";
import { clearAuthToken, getAuthToken } from "../utils/auth";

const Header = () => {
  const navigate = useNavigate();
  const isAuthenticated = !!getAuthToken();
  const location = useLocation();
  const role = location?.state?.role || localStorage.getItem("role");

  const handleLogout = async () => {
    await clearAuthToken();
    navigate("/");
    window.location.reload();
  };

  const handleLogin = () => {
    navigate("/login");
    window.location.reload();
  };

  const handleMyPostsClick = (event) => {
    event.preventDefault();
    navigate("/dashboard");
  };
  const handlePostsClick = (event) => {
    event.preventDefault();
    navigate("/admin");
  };

  const handleToggleClick = (e) => {
    e.preventDefault();
    let bodyElement = document.body;
    if (bodyElement.classList.contains("menu_open")) {
      bodyElement.classList.remove("menu_open");
    } else {
      bodyElement.classList.add("menu_open");
    }
  };

  const handleLiClick = (e) => {
    e.preventDefault();
    let bodyElement = document.body;
    if (bodyElement.classList.contains("menu_open")) {
      bodyElement.classList.remove("menu_open");
    }
  };

  // Close the menu when any link inside the nav bar is clicked
  const navLinks = document.querySelectorAll("ul.nav-bar li a"); // This will select all anchor tags inside the ul.nav-bar li

  navLinks.forEach((link) => {
    link.addEventListener("click", () => {
      document.body.classList.remove("menu_open");
    });
  });

  return (
    <>
      <div className="top-bar">
        <div className="container">
          <div className="main-top-flex">
            <div className="top-bar-left">
              <ul className="top-bar-follow">
                <li>Follow Us:</li>
                <li>
                  <a href="!#">
                    <img src={facebookIcon} alt="" />
                  </a>
                </li>
                <li>
                  <a href="!#">
                    <img src={twitterIcon} alt="" />
                  </a>
                </li>
                <li>
                  <a href="!#">
                    <img src={instagramIcon} alt="" />
                  </a>
                </li>
              </ul>
            </div>
            <div className="top-bar-contact">
              <ul className="top-bar-contact">
                <li>
                  <img src={callIcon} alt="" />
                  <a href="tel:+204-588-7755">+204-588-7755</a>
                </li>
                <li className="border-left">
                  <img src={ic_baseline} alt="" />
                  <a href="mailto:info@flyingcharity.com">
                    info@flyingcharity.com
                  </a>
                </li>
              </ul>
            </div>
            <div className="logo">
              <a href="/">
                <img src={logoIcon} alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <header className="website-header">
        <div className="container">
          <div className="nav-flex">
            <nav className="web-nav-flex">
              <div className="logo-mob">
                <a href="/">
                  <img src={logoIcon} alt="" />
                </a>
              </div>
              <input type="checkbox" id="check" />
              <label htmlFor="check" className="checkbtn">
                <i className="fas fa-bars"></i>
              </label>
              <ul className="nav-bar">
                {!isAuthenticated && (
                  <>
                    <li onClick={handleLiClick}>
                      <NavLink className="" to="/">
                        Home
                      </NavLink>
                    </li>
                    <li onClick={handleLiClick}>
                      <NavLink to="/about">About</NavLink>
                    </li>
                    {/* <li onClick={handleLiClick}>
                      <NavLink to="/blogs">Blog</NavLink>
                    </li> */}
                    <li onClick={handleLiClick}>
                      <NavLink to="/contact">Contact Us</NavLink>
                    </li>
                    <li
                      className="for_mobile mobile_link"
                      aria-label="Login"
                      onClick={handleLogin}
                    >
                      Login/Register
                    </li>
                  </>
                )}
                {isAuthenticated && (
                  <>
                    {role === "" && (
                      <>
                        <li onClick={handleLiClick}>
                          <NavLink className="" to="/">
                            Home
                          </NavLink>
                        </li>
                        <li onClick={handleLiClick}>
                          <NavLink to="/about">About</NavLink>
                        </li>
                        {/* <li onClick={handleLiClick}>
                          <NavLink to="/blogs">Blog</NavLink>
                        </li> */}
                        <li onClick={handleLiClick}>
                          <NavLink to="/contact">Contact Us</NavLink>
                        </li>
                        <li
                          className="for_mobile mobile_link"
                          aria-label="Login"
                          onClick={handleLogin}
                        >
                          Login/Register
                        </li>
                      </>
                    )}
                    {role === "user" && (
                      <>
                        <li onClick={handleLiClick}>
                          <NavLink className="" to="/">
                            Home
                          </NavLink>
                        </li>
                        <li onClick={handleLiClick}>
                          <NavLink to="/about">About</NavLink>
                        </li>
                        {/* <li onClick={handleLiClick}>
                          <NavLink to="/blogs">Blog</NavLink>
                        </li> */}
                        <li onClick={handleLiClick}>
                          <NavLink to="/contact">Contact Us</NavLink>
                        </li>
                        <li onClick={handleLiClick}>
                          <NavLink to="dashboard" onClick={handleMyPostsClick}>
                            Dashboard
                          </NavLink>
                        </li>
                        <li onClick={handleLiClick}>
                          <NavLink to="/profile">My Profile</NavLink>
                        </li>
                        <li
                          className="for_mobile mobile_link"
                          aria-label="Login"
                          onClick={
                            !isAuthenticated ? handleLogin : handleLogout
                          }
                        >
                          {!isAuthenticated ? "Login/Register" : "Logout"}
                        </li>
                      </>
                    )}
                    {role === "admin" && (
                      <>
                        <li onClick={handleLiClick}>
                          <NavLink className="" to="/">
                            Home
                          </NavLink>
                        </li>
                        <li onClick={handleLiClick}>
                          <NavLink to="/admin" onClick={handlePostsClick}>
                            Admin Panel
                          </NavLink>
                        </li>
                        {/* <li onClick={handleLiClick}>
                          <NavLink to="/blogs">Blog</NavLink>
                        </li> */}
                        <li onClick={handleLiClick}>
                          <NavLink to="/users">Users</NavLink>
                        </li>
                        <li onClick={handleLiClick}>
                          <NavLink to="/profile">My Profile</NavLink>
                        </li>
                        <li
                          className="for_mobile mobile_link"
                          aria-label="Login"
                          onClick={
                            !isAuthenticated ? handleLogin : handleLogout
                          }
                        >
                          {!isAuthenticated ? "Login/Register" : "Logout"}
                        </li>
                      </>
                    )}
                  </>
                )}
              </ul>

              <button
                className="login-btn"
                aria-label="Donate Now"
                onClick={() => {
                  navigate("/posts");
                }}
              >
                Donate Now
              </button>
              <button
                className="login-btn"
                aria-label="Login"
                onClick={!isAuthenticated ? handleLogin : handleLogout}
              >
                {!isAuthenticated ? "Login/Register" : "Logout"}
              </button>
            </nav>
            <div
              className="menu_icon"
              style={{ display: "none" }}
              onClick={handleToggleClick}
            >
              <svg
                width="800px"
                height="800px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 18L20 18"
                  stroke="#000000"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M4 12L20 12"
                  stroke="#000000"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M4 6L20 6"
                  stroke="#000000"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;